"use client";

import { PropsWithChildren } from "react";
import { TmaUnavailablePage } from "@/components/layout/TmaUnavailablePage";
import { useTelegramContext } from "@/contexts/TelegramContext";

export function TmaUnavailableWrapper({ children }: PropsWithChildren) {
  const { isTMA } = useTelegramContext();

  if (isTMA) {
    return <TmaUnavailablePage />;
  }

  return <>{children}</>;
}
